<template>
  <div>

  <div class="invoice_container"  v-if="whollyObtained == 0">
    

    <div class="basic_info2 boxshadow1" style="margin-top: 20px;">
      
      <div class="section-content" >
        <div class="caption" style="font-weight: 700;">成品与原材料</div>
        <div class="cell">
          <div  @click.prevent="isShowMore = !isShowMore"
          class="search"
          style="color:#39f;font-weight:bold;padding-bottom:5px;width:100%;height:40px;"
        >
          
          <Button
            type="primary"
            style="float:right"
            size="small"
           
            >{{ !isShowMore ? "展开" : "收起" }}</Button
          >
        </div>
          <div class="product_info">
            <div class="product_detail" style="position:relative;">
              <Form ref="form" :model="product" @submit.native.prevent >
                <Row :gutter="16" class="line1"  >
                  <Col span="5" class="pn">
                    <FormItem prop="goodsName">
                      <span class="title">进口国/地区：{{ product.importer }}</span>
                      
                     
                    </FormItem>
                  </Col>
                  <Col span="5" class="exporter">
                    <FormItem prop="invoiceCode">
                      <span class="title">原产国/地区： {{ product.exporter }}</span>
                     
                    
                    </FormItem>
                  </Col>
                  <Col span="5" class="exporter">
                    <FormItem prop="exporter">
                      <span class="title">产品料号：{{ product.goodsPN }}</span>
                      
                     
                    </FormItem>
                  </Col>
                  <Col span="5" class="exporter">
                    <FormItem prop="importer">
                      <span class="title">产品中文名称：{{ product.goodsName }}</span>
                 
                    
                    </FormItem>
                  </Col>
                </Row>
                <Row :gutter="16" class="line2">
                  <Col span="5" class="importer">
                    <FormItem prop="goodsPN">
                      <span class="title">产品HS编码：{{ product.goodsCode }}</span>
                    
                    
                    </FormItem>
                  </Col>
                  <Col span="5" class="name">
                    <FormItem prop="goodsCode">
                      <span class="title">单位产品离岸价格：{{ product.goodsPrice }}</span>
                     
                    
                    </FormItem>
                  </Col>
                  <Col span="5" class="name">
                    <FormItem prop="goodsCode">
                      <span class="title">发票号：{{ product.invoiceCode }}</span>
                      
                     
                    </FormItem>
                  </Col>
                  <Col span="5" class="key">
                    <FormItem prop="goodsWeight">
                      <span class="title">规格型号</span>
                      <div class="tgroup_wrap">
                      
                      </div>
                    </FormItem>
                  </Col>
               
                </Row>
                
              
              </Form>
              <img src="~@/assets/images/home/success.png" class="ok_status" style="right: 10%;
              top: 15%;width: 150px;;
            " v-if="parseInt(dataSet.status) === 1">
              <img src="~@/assets/images/home/fail.png" class="fail_status" style="right: 10%;
              top:15%;width: 150px;
            " v-else-if="!_.isEmpty(dataSet)">
            </div>
            <div class="material_list" id="files_list" v-show="isShowMore">
              <div class="table-containter">
                <div class="table-wrap">
                  <Table
                    :columns="query.columns"
                    :data="dataSet.materials"
                    :height="
                      dataSet.materials && dataSet.materials.length > 20
                        ? 300
                        : '-'
                    "
                    no-data-text="暂无记录"
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- <div
      class="search"
      style="color:#39f;font-weight:bold;margin-bottom:15px;font-size:14px"
    >
     
    判定结果1: <span style="margin-right:20px"  v-for="item in dataSet.ftas"
    :key="item.id"> <span v-if="item.status==1" style="color:rgb(6, 224, 6);margin-right:10px">{{item.ftaName}}符合</span> <span v-else style="color:rgb(236, 59, 59)">{{item.ftaName}}不符合</span> </span>  
</div> -->
    <div class="ftas">
      <div class="ftas" v-if="dataSet.ftas && dataSet.ftas.length > 0">
        <div class="fta boxshadow1">
          <Tabs>
            <TabPane
              :label="lableName(item)"
              v-for="item in dataSet.ftas"
              :key="item.id"
            >
              <PanelContent
                :wo="dataSet.wo"
                :specialCraft="dataSet.specialCraft"
                :imported="dataSet.imported"
                :voteStatus="dataSet.status"
                :materials="dataSet.materials"
                :dataSet="item"
              />
            </TabPane>
          </Tabs>
        </div>
      </div>
      <div class="empty_ftas" v-else-if="dataSet && dataSet.id">
        <div class="desc">
          <svg-icon icon-class="found"></svg-icon>没有符合条件的FTA
        </div>
      </div>
    </div>
  
  </div>
  <div class="invoice_container"  v-if="whollyObtained == 1">
    

    <div class="basic_info2 boxshadow1">
      
      <div class="section-content" >
        <div class="caption" style="font-weight: bold;">成品与原材料</div>
        <div class="cell">
          <div  @click.prevent="isShowMore = !isShowMore"
          class="search"
          style="color:#39f;font-weight:bold;padding-bottom:5px;width:100%;height:40px;"
        >
          
          <Button v-if="dataSet.status != 1"
            type="primary"
            style="float:right"
            size="small"
           
            >{{ !isShowMore ? "展开" : "收起" }}</Button
          >
        </div>
          <div class="product_info">
            <div class="product_detail">
              <Form ref="form" :model="product" @submit.native.prevent>
                <Row :gutter="16" class="line1">
                  <Col span="6" class="pn">
                    <FormItem prop="goodsName">
                      <span class="title">贸易国/地区: {{ product.exporter }}</span>
                     
                     
                    </FormItem>
                  </Col>
                  <Col span="6" class="exporter">
                    <FormItem prop="invoiceCode">
                      <span class="title">成品商品编码: {{ product.goodsCode }}</span>
                     
                    
                    </FormItem>
                  </Col>
                 
                </Row>
                
               
              </Form>
            </div>
            <div class="material_list" id="files_list" v-show="isShowMore">
              <div class="table-containter">
                <div class="table-wrap">
                  <Table
                    :columns="query.columns"
                    :data="dataSet.materials"
                    :height="
                      dataSet.materials && dataSet.materials.length > 20
                        ? 300
                        : '-'
                    "
                    no-data-text="暂无记录"
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- <div
      class="search"
      style="color:#39f;font-weight:bold;margin-bottom:15px;font-size:14px"
    >
     
    判定结果: <span style="margin-right:20px"  v-for="item in dataSet.ftas"
    :key="item.id"> <span v-if="item.status==1" style="color:rgb(6, 224, 6);margin-right:10px">{{item.ftaName}}符合</span> <span v-else style="color:rgb(236, 59, 59)">{{item.ftaName}}不符合</span> </span>  
</div> -->
    <div class="ftas">
      <div class="ftas" v-if="dataSet.ftas && dataSet.ftas.length > 0">
        <div class="fta boxshadow1">
          <Tabs>
            <TabPane
              :label="lableName(item)"
              v-for="item in dataSet.ftas"
              :key="item.id"
            >
              <PanelContent
                :wo="dataSet.wo"
                :specialCraft="dataSet.specialCraft"
                :imported="dataSet.imported"
                :voteStatus="dataSet.status"
                :materials="dataSet.materials"
                :dataSet="item"
              />
            </TabPane>
          </Tabs>
        </div>
      </div>
      <div class="empty_ftas" v-else-if="dataSet && dataSet.id">
        <div class="desc">
          <svg-icon icon-class="found"></svg-icon>没有符合条件的FTA
        </div>
      </div>
    </div>
    <HistoryModal
      :isShow="isShowModal"
      :dataSet="dataSet"
      @changeState="isShowModal = $event"
    ></HistoryModal>
  </div>
</div>
</template>

<script>
import PanelContent from "./VoteResultPanel3";
import FileUpload from "./FileUpload";
import HistoryModal from "./historyModal";

export default {
  name: "VoteResult",
  components: { PanelContent, FileUpload, HistoryModal },
  props: {
    dataSet: {
      type: Object,
      default: () => {
        return {};
      },
      required: false
    },
    whollyObtained: {
      type: String,

      required: false
    }
  },
  data() {
    return {
      collapse: false,
      isShowMore: false,

      columns: [
        {
          title: "原材料料号",
          key: "materialPN",
          align: "center",
       
          ellipsis: true
        },
        {
          title: "原材料属性",
          key: "materialType",
          align: "center",
        
          ellipsis: true
        },
        {
          title: "原材料名称",
          key: "materialName",
          align: "center",
        
          ellipsis: true
        },
        {
          title: "原材料商品编码",
          key: "materialCode",
          align: "center",
          ellipsis: true,
        
        },
        {
          title: "原材料单价",
          key: "materialPrice",
          align: "center",
       
          ellipsis: true
        },
        // { title: '原材料单位', key: 'materialUnit', align: 'center', width: 100 },
        {
          title: "原材料重量",
          key: "materialWeight",
          align: "center",
          ellipsis: true,
        
        },
        {
          title: "原材料原产地",
          key: "materialOrigin",
          align: "center",
          ellipsis: true,
         
        },
        {
          title: "原材料备注",
          key: "materialDescription",
          align: "center",
          ellipsis: true,
        
        }
      ],

      isShowModal: false,
      isShowSpecialCraft: false,
      weightUnitArr: [{name:'吨',value:'t'},{name:'千克',value:'kg'}, {name:'克',value:'g'}, {name:'毫克',value:'mg'}, {name:'微克',value:'ug'}, {name:'磅',value:'b'}, {name:'盎',value:'oz'}],
      specialCraftDesc: "",
      lableName(data) {
        return h => {
          return h('div', [
            h('span', {
                      style:{  fontSize: '16px',fontWeight: 700,
    color: '#333'},
                
                    }, data.ftaName),
            h('span', {style:{color: data.status == 1 ? '#06e006' : '#ec3b3b', 'font-size': '16px', 'padding-left': '0px' }},  data.status == 1 ? '（符合）' : '（不符合）')
          ])
        }
      },
      product: {
        // companyCode: '',
        importer: "",
        exporter: "",
        invoiceCode: "",
        goodsPN: "",
        goodsName: "",
        goodsCode: "",
        goodsPrice: null,
        // goodsCount: '',
        goodsWeight: null,
        weightUnit: "kg",
        unit: "CNY",
        goodsDescription: "",
        imported: "N",
        // wo: 0,
        // specialCraft: 0
        // wo: 'N',
        specialCraft: "N"
      },
      query: {
        columns: [
          { title: "原材料料号", key: "materialPN", align: "center" },
          {
            title: "原材料属性",
            key: "materialType",
            align: "center",
            ellipsis: true,
            render: (h, params) => {
              return h(
                "span",
                {
                  attrs: {
                    title: params.row.materialType
                  }
                },
                params.row.materialType
              );
            }
          },
          {
            title: "原材料名称",
            key: "materialName",
            align: "center",
            ellipsis: true,
            render: (h, params) => {
              return h(
                "span",
                {
                  attrs: { title: params.row.materialName }
                },
                params.row.materialName
              );
            }
          },
          {
            title: "原材料商品编码",
            key: "materialCode",
            align: "center",
            ellipsis: true,
            render: (h, params) => {
              return h(
                "span",
                {
                  attrs: { title: params.row.materialCode }
                },
                params.row.materialCode
              );
            }
          },
          {
            title: "原材料单价",
            key: "materialPrice",
            align: "center",
            ellipsis: true,
            render: (h, params) => {
              return h(
                "span",
                (this.$options.filters.amountThousands(
                  params.row.materialPrice || 0
                ) || "-") + params.row.materialUnit
              );
            }
          },
          // {title: '原材料单位', key: 'materialUnit', align: 'center', ellipsis: true, width: 120,},
          {
            title: "原材料重量",
            key: "materialWeight",
            align: "center",
            render: (h, params) => {
              return h("span", params.row.materialWeight || "-");
            }
          },
          {
            title: "原材料原产地",
            key: "materialOrigin",
            ellipsis: true,
            align: "center"
          },
          {
            title: "原材料备注",
            key: "materialDescription",
            align: "center",
            ellipsis: true,
            render: (h, params) => {
              return h(
                "span",
                {
                  attrs: { title: params.row.materialDescription || "-" }
                },
                params.row.materialDescription || "-"
              );
            }
          }
        ]
      }
    };
  },
  watch: {
    dataSet(newVal, oldVal) {
     let _this = this
      if (newVal && newVal.id) {
        debugger
        // this.product = this._.assign({}, newVal)
        // this.product.wo = parseInt(this.product.wo) === 1 ? 1 : 0
        // this.product.specialCraft = parseInt(this.product.specialCraft) === 1 ? 1 : 0
        // this.product.wo = this.product.wo === 1 || this.product.wo == 'Y' ? 'Y' : 'N'
        // this.product.specialCraft = this.product.specialCraft === 1 || this.product.specialCraft == 'Y' ? 'Y' : 'N'
        _.forEach(this.product, (value, key) => {
          if (key == "goodsWeight") {
            let [weight, weightUnit] = _this.splitWeightUnit(newVal[key] || "");
            _this.product[key] = weight;
            _this.product["weightUnit"] = weightUnit;
          } else if (["imported", "specialCraft"].indexOf(key) != -1) {
            _this.product[key] =
              newVal[key] == 1 || newVal[key] == "Y" ? "Y" : "N";
          } else if (key != "weightUnit") {
            _this.product[key] = newVal[key];
          }
        });
        _this.checkShowSpecialCraft();
      }
    }
  },
  methods: {
    splitWeightUnit(val) {
      if (this._.trim(val)) {
        let reg = /[a-zA-Z]+?$/;
        if (reg.test(val)) {
          let tmp = val.match(reg)[0],
            tmp2 = val.replace(tmp, "");
       
   
         
          tmp = this.weightUnitArr.findIndex(item=>item.value==tmp)!= -1 ? tmp : "";
          return [parseFloat(tmp2) || null, tmp];
        }
      }
      return [null, ""];
    },
    checkShowSpecialCraft() {
      if (
        this._.trim(this.product.importer) &&
        this._.trim(this.product.exporter) &&
        this._.trim(this.product.goodsCode)
      ) {
        this.$api.query.rule2(
          this.product.exporter,
          this.product.importer,
          this.product.goodsCode,
          {
            success: response => {
              if (response.data.code === 200) {
                let ftas = response.data.data.ftas;
                if (!this._.isEmpty(ftas)) {
                  let criterions = _.reduce(
                    ftas,
                    function(res, item) {
                      res.push(...item.criterion);
                      return res;
                    },
                    []
                  );
                  let _criterion = this._.find(criterions, o =>
                    /加工工序/.test(o.name)
                  );
                  if (_criterion) {
                    this.specialCraftDesc = _criterion.description || "";
                    this.product.specialCraft =
                      this.product.specialCraft || "N";
                    this.isShowSpecialCraft = true;
                  } else {
                    this.product.specialCraft = "";
                    this.isShowSpecialCraft = false;
                  }
                }
              } else {
                this.product.specialCraft = "";
                this.isShowSpecialCraft = false;
              }
            },
            error: error => {
              this.product.specialCraft = "";
              this.isShowSpecialCraft = false;
            }
          }
        );
      } else {
        this.product.specialCraft = "";
        this.isShowSpecialCraft = false;
      }
    },
    historyHandle() {
      this.isShowModal = true;
    },
    uploadHandle() {
      if (this.isShowMore) {
        document.getElementById("files_list").scrollIntoView();
        setTimeout(() => {
          this.$refs.fileUploadRef && this.$refs.fileUploadRef.upload();
        }, 100);
      } else {
        this.isShowMore = true;
        setTimeout(() => {
          document.getElementById("files_list").scrollIntoView();
          // setTimeout(() => {
          this.$refs.fileUploadRef && this.$refs.fileUploadRef.upload();
          // }, 100)
        }, 350);
      }
    }
  }
};
</script>

<style scoped>
#files_list >>>.ivu-table-header table{
  width: 100% !important;
}
.base_info{
  margin-bottom: 30px;
  margin-top: 15px;
  padding: 18px 18px 16px;
  background-color: #bc8cf0;
  color: #fff;
}
.base_info .slogo-title{
  font-size: 16px;
  font-weight: bold;
  /* color: #323232; */
  color: #fff;
 
}
.base_info .slogo-content{
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.base_info .slogo-content .item{
  width: 20%;
}
.base_info .item.timer{
  width: 40%;
}
.base_info .slogo-content .item-title{
  font-size: 16px;
  color: #8b8989;
  margin-bottom: 3px;

  color: #fff;
}
.base_info .slogo-content .item-value{
  font-size: 16px;
  position: relative;
}
.base_info .svg-icon{
  margin-right: 5px;
  font-size: 16px;
}
.base_info .success{
  color:#00b55f;
  padding-right:10px;
  visibility: hidden;
}
.base_info .error{
  color:#ff4d4d;
  padding-right:10px;
  visibility: hidden;
}
.ok_status, .fail_status{
  position: absolute;
  width: 120px;
  top: 50%;
  transform: translate(-10%, -30%) rotate(10deg);
  z-index: 1;
}
.status_title{
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
}
.base_info .item.timer .item-value{
  display: flex;
  align-items: center;
}
.base_info .history{
  color: #fff;
  cursor: pointer;
  border: 1px solid #0774b5;
  background-color: #0774b5;
  padding: 3px 0;
  display: block;
  width: 130px;
  text-align: center;
  font-size: 14px;
  border-radius: 3px;
  margin-left: 20px;
  font-weight: bold;
}
.base_info .history:hover{
  background-color: #828df9;
  border-color: #828df9;
}
.basic_info2{
  margin-bottom: 30px;
  padding: 14px 18px;
  border-bottom: 1px solid #ccc;
}
.basic_info2 .boprs{
  display: flex;
}
.basic_info2 .boprs .lookpd{
  display: block;
  margin-right: 15px;
  padding: 0 10px;
  border: 1px solid #f37e6c;
  background-color: #f37e6c;
  color: #fff;
  border-radius: 3px;
  text-align: center;
  box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
}
.basic_info2 .boprs .lookpd:hover{
  background-color: #ffa799;
  border-color: #ffa799;
}
.basic_info2 .materials{
  border: 1px solid #0774b5;
  background-color: #0774b5;
  width: 60px;
  color: #fff;
  border-radius: 3px;
  text-align: center;
  display: block;
  /* color: #0774b5; */
}
.basic_info2 .materials:hover{
  background-color: #03639c;
  border-color: #03639c;
}
  .breadcrumbs{
    font-size: 16px;
    color: #333;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
  }
  .breadcrumbs >>> .ivu-tooltip span span{
    color: #0774b5;
    font-weight: bold;
    cursor: default;
  }
.section-content{
  padding: 18px 18px 3px 0;
}
.caption{
  font-size: 16px;
  color: #333;
  background: url("~@/assets/images/home/guide.png") 0 center no-repeat transparent;
  background-size: 12px;
  padding-left: 18px;

  position: relative;
}
  .product_meta .pn{
    padding: 0 15px;
  }
  .product_meta .materials{
    background: url("~@/assets/images/coo/icon_hs.png") no-repeat right center transparent;
    background-size: 7px auto;
    padding-right: 12px;
  }
  .product_meta .materials.active{
    background-image: url("~@/assets/images/coo/icon_xl.png");
    background-size: 8px;
  }
  .product_info{
    margin: 0;
  }
  .slide-fade-enter-active {
    transition: all .2s ease;
  }
  .slide-fade-leave-active {
    transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateY(-50px);
    opacity: 0;
  }
  .material_list{
    margin-bottom: 12px;
    position: relative;
  }
  .table-containter{
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 3px;
  }
  .table-wrap{
    width: 100%;
    border: 1px solid #eaf7ff;
  }
  .table-wrap >>>.ivu-table-wrapper .ivu-table-header table{
    width: 100% !important;
    
  }
  .product_detail,
  .file_list{
    background-color: #fff;
    /* box-shadow: 0 2px 4px 0 rgba(196,196,196,0.50); */
    padding: 22px 18px 5px;
    margin-bottom: 30px;
    font-size: 13px;
  }
  .product_detail{
    padding-top: 0;
    /* padding-bottom: 25px; */
  }
  .file_list{
    margin-bottom: 30px;
    padding-bottom: 15px;
  }
  .product_detail >>> .ivu-form-item{
    margin-bottom: 0;
    width: 90%;
  }
  .product_detail >>> .ivu-col.remark .ivu-form-item{
    width: 95.3%;
  }
  .product_detail >>> .ivu-col.specialgy .ivu-form-item{
    width: 98.5%;
  }
  .product_detail >>> .scdesc{
    background-color: #e6f1fd;
    border-radius: 6px;
    display: inline-block;
    padding: 5px 10px;
    line-height: 26px;
    font-size: 14px;
  }
  .product_detail >>> .ivu-form-item-content{
  }
  .product_detail >>> .ivu-row{
    margin-bottom: 5px;
  }
  .product_detail >>> .ivu-row:last-child{
    margin-bottom: 0;
  }
  .product_detail >>> .ivu-row .ivu-col{
    display: flex;
    align-items: center;
    height: 32px;
    height: 100%;
  }
  .product_detail >>> .ivu-row .ivu-col .title{
    white-space: nowrap;
    font-size: 16px;
    color: #999;
  }
  .product_detail >>> .ivu-row .ivu-col .ivu-input,
  .product_detail >>> .ivu-row .ivu-col .ivu-input-number,
  .product_detail >>> .ivu-row .ivu-col .ivu-select-selection,
  .product_detail >>> .ivu-row .ivu-col .ivu-input-number-input{
    border-radius: 2px;
    background-color: #fbfafa;
    border-color: #fff;
    color: #333;
    font-size: 16px;
    opacity: 1;
  }
  .product_detail >>> .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .product_detail >>> .ivu-row .ivu-col ::placeholder{
    color: #333;
  }
  .product_detail >>> .ivu-select-selected-value,
  .product_detail >>> .ivu-select-item{
    font-size: 16px !important;
  }
  .product_detail >>> .ivu-checkbox-wrapper{
    font-size: 16px;
    color: #333;
  }
  .product_detail >>> .ivu-row .ivu-col .ivu-form-item-error .ivu-input{
    border-color: #ed3f14;
  }
  .product_detail >>> .ivu-row .ivu-col .ivu-input:focus{
    border-color: #57a3f3;
  }
  .material_list >>> .ivu-table-wrapper{
    border: 0 none;
  
  }
  .material_list >>> .ivu-table{
    background-color: #fff;
    box-shadow: 0 2px 4px 0 rgba(196,196,196,0.50);
  }
  .material_list >>> .ivu-table th{
    background-color: rgba(31, 138, 252, 0.05);
    border-bottom: 0 none;
    font-size: 14px;
    font-weight: bold;
    border-color: #eaf7ff;
  }
  .material_list >>> .ivu-table th span,.material_list >>> .ivu-table td span{
    white-space: nowrap;
  }
  .material_list >>> .ivu-table td{
    border-color: #f1f1f1;
    font-size: 16px;
  }
  .fta{
    position: relative;
  }
  .fta >>> .ivu-tabs-bar{
    /* border-bottom: 0 none; */
    margin-bottom: 0;
  }
  .fta >>> .ivu-tabs-nav{
    border-color: #eee;
  }
  .fta >>> .ivu-tabs-tabbar{
    background-color: #2681FF;
  }
  .fta >>> .ivu-tabs-ink-bar{
    height: 2px;
    background-color: #0774b5;
  }
  .fta >>> .ivu-tabs-tabpane{
    /*padding: 0 2px;*/
    background-color: #fff;
    padding: 20px 18px 0;
    /* -webkit-box-shadow: 0 2px 4px 0 rgba(223, 223, 223, .50);
    box-shadow: 0 2px 4px 0 rgba(223, 223, 223, .50); */
  }
  .ftas{
    position: relative;
  }
  .ftas .coo_timer{
    position: absolute;
    right: 5px;
    top: 10px;
    color: #999;
    font-size: 14px;
  }
  .ftas .fta:last-child >>> .ivu-tabs-tabpane{
    margin-bottom: 5px;
  }
  .fta{
    margin-bottom: 30px;
  }
  .fta:last-child{
    margin-bottom: 0;
  }
  .fta >>> .ivu-tabs-tab{
    font-size: 1.5rem;
    color: #999;
    padding: 14px 18px;
  }
  /*.fta >>> .ivu-tabs-nav .ivu-tabs-tab:nth-of-type(2){*/
  /*padding-right: 0;*/
  /*position: relative;*/
  /*left: -14px;*/
  /*}*/
  .fta >>> .ivu-tabs-tab-active{
    /* color:  #0774b5; */
  }
  .fta >>> .ivu-tabs-tab:hover{
    color:  #0774b5;
  }

  .btn{
    width: 150px;
    border: 1px solid #1F8AFD;
    border-radius: 3px;
    height: 32px;
    /*line-height: 32px;*/
    float: left;
    /*font-size: 12px;*/
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
  }
  .btn span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btn.coo{
    background-color: #0774b5;
    border-color: #0774b5;
    color: #fff;
    font-size: 16px;
    margin-right: 15px;
  }
  .btn.ivu-btn-loading{
    cursor: default;
  }
  .btn.ivu-btn-loading span{
    position: static;
    transform: none;
  }
  .btn.save{
    background-color: #fff;
    color: #0774b5;
    border-color: #0774b5;
  }
  .btn.save[disabled],
  .btn.coo[disabled]{
    color: #bbbec4;
    /*background-color: #f7f7f7;*/
    border-color: #dddee1;
    cursor: default;
  }
  .empty_ftas{
    padding-top: 0px;
  }
  .empty_ftas img{
    display: block;
    width: 180px;
    margin: 0 auto;
  }
  .empty_ftas .desc{
    text-align: center;
    font-size: 16px;
    color: #999;
    margin-top: 20px;
  }
  .empty_ftas .svg-icon{
    font-size: 18px;
    color: #999;
    margin-right: 3px;
  }
.tgroup_wrap{
  position: relative;
  padding-right: 73px;
}
.tgroup_wrap .tgroup_item2{
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width:70px;
  margin-top: 0.5px;
}

.tgroup_wrap .ivu-input-number{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/VoteResult.vue